/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileXblrTemplateShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M3 2v12h2V6h14v4h2V2zm16 17v1H8v2h13v-3z" />
        <path d="m6.806 17 1.501-2.526-1.427-2.345h1.2l1.004 1.682.979-1.682h1.152l-1.434 2.365L11.29 17h-1.2l-1.085-1.843L7.96 17zm5.016 0v-4.871h1.708c.621 0 1.077.105 1.367.315.295.21.442.536.442.978 0 .219-.058.415-.174.59s-.277.312-.482.415c.576.179.864.56.864 1.146 0 .951-.659 1.427-1.977 1.427zm1.005-2.854h.509c.353 0 .6-.045.743-.134.148-.094.222-.25.222-.47 0-.227-.072-.386-.215-.475-.143-.094-.393-.14-.75-.14h-.51zm0 2.05h.663c.344 0 .596-.054.757-.161s.241-.275.241-.502c0-.224-.08-.387-.241-.49s-.413-.154-.757-.154h-.663zm3.372.804v-4.871h1.87c.58 0 1.026.134 1.34.402.312.268.468.648.468 1.139 0 .344-.09.636-.268.878a1.416 1.416 0 0 1-.744.516L20.085 17h-1.153l-1.031-1.749-.664-.167V17zm1.038-2.6h.51c.406 0 .687-.051.844-.154.16-.107.24-.293.24-.556s-.08-.447-.24-.55c-.157-.107-.438-.16-.845-.16h-.509zm3.378 2.6v-4.871h1.046v3.94h2.144v.93zm-18.141.474L1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileXblrTemplateShortcut as FileXblrTemplateShortcut };
